<template>
  <div>
    <div class="imgBox">
      <img :src="picUrl" class="goods-img" />
    </div>
    <div class="item-name">{{ goodsName }}</div>
    <div class="tags-1">
      <div class="tags-item" v-for="(act, index) in actTitleDTOS" :key="index">
        <span>{{ actMatchList[act.actType] }}</span>
<!--        <span v-if="!tags.actType">优惠券</span>
        <span v-else>{{ tags.actPromotion.actTag }}</span>-->
      </div>
    </div>
    <div class="priceBox">
      <span class="rmb" :style="{ 'margin-left': '8px' }">¥</span>
      <span class="discount">{{ shopPrice.toFixed(2) }}</span>
      <span class="price">¥{{ marketPrice.toFixed(2) }}</span>
    </div>
  </div>
</template>

<script>
import { actMatchList } from '../common'
export default {
  props: [
    'goodsName',
    'marketPrice',
    'shopPrice',
    'actTitleDTOS',
    'picUrl',
    'type'
  ],
  data () {
    return {
      actMatchList: actMatchList
    }
  },
  computed: {},
  created () {
    // let actTitleDTOS = this.actTitleDTOS || []
    // actTitleDTOS.forEach(v1 => {
    //   this.$set(v1, 'myTitle', v1.actTag)
    // })
  }
}
</script>

<style lang="stylus" scoped>
.goods-img {
  object-fit: contain;
}

.item-name
    margin-left: 10px
    height: 30px;
    line-height: 30px;
    font-size 14px
    font-weight: 500;
    padding 0
    overflow hidden
    white-space nowrap
    text-overflow ellipsis
    color: #000000;
    opacity: 0.8;
.tags-1
    height: 20px
    margin-left: 10px
    display: flex
    flex-wrap: wrap;
.no-tag
    background:none !important;
    border: 1px solid rgba(0,0,0,0) !important;
.tags-item
    min-height: 15px
    height: 15px;
    background: rgba(252, 76, 0, 0.05);
    border: 0.4px solid #FC4C00;
    border-radius: 2px;
    font-size: 10px;
    line-height: 15px;
    color: #FC4C00;
    padding: 2px 3px
    margin:2px
    margin-left:0
    overflow hidden
    white-space nowrap
    text-overflow ellipsis
.imgBox
  width 100%
  height 163px
.imgBox img
  width 100%
  height 100%
 .priceBox
  height 30px
  line-height 20px
  vertical-align middle
  margin-bottom 8px
 .priceBox .rmb
  margin-left 8px
  font-size: 12px;
  line-height: 17px;
  text-align: right;
  color #FF5600
 .priceBox .discount
  margin-left 3px
  color #FF5600
  font-weight: 600;
  font-size: 16px;
  line-height: 25px;
 .priceBox .price
  color: #7d7e80
  text-decoration:line-through
  margin-left 6px
  font-size: 12px;
  line-height: 17px;
</style>
